import { useMemo } from 'react';
import { keyBy } from 'lodash-es';
import { useLocation } from 'react-router';
import { useDevice } from 'seagull';
import { useRootDevice } from "../providers/DeviceProvider";
import { getHomePagePages } from "../utils/routeConfigs";
import { useFeatureFlags } from "./useFeatureFlags";
export function useIsMobileForHomePage() {
  const {
    isMobileDevice
  } = useDevice();
  const {
    isMobileDevice: isMobileDeviceFromRoot
  } = useRootDevice();
  const {
    DASHBOARD_MOBILE = false,
    AGREEMENTS_DASHBOARD_MOBILE = false
  } = useFeatureFlags();
  const location = useLocation();
  const homePagePages = useMemo(() => keyBy(getHomePagePages({
    DASHBOARD_MOBILE,
    AGREEMENTS_DASHBOARD_MOBILE
  }), 'url'), [DASHBOARD_MOBILE, AGREEMENTS_DASHBOARD_MOBILE]);
  return useMemo(() => {
    var _homePagePages$locati;
    return isMobileDevice || isMobileDeviceFromRoot && !!((_homePagePages$locati = homePagePages[location.pathname]) !== null && _homePagePages$locati !== void 0 && _homePagePages$locati.supportsMobileDevice);
  }, [isMobileDevice, isMobileDeviceFromRoot, homePagePages, location.pathname]);
}